import React from "react";
import { Container, Form } from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useHistory } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import { addCompany } from "../../../api/companies";
import * as Yup from "yup";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { MEDIA_FIELDS_REQUIRED } from "./CONSTANT";
import CompanyForm from "./CompanyForm";

const TYPES = {
  select: null,
  "add-more": [],
  checkbox: false,
  file: null,
  date: null,
  "file-v2": null,
};

const initialValues = {};
const FIELDS_VALIDATION = {};

MEDIA_FIELDS_REQUIRED.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "";
  if (f.type == "file") {
    FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
      "This Field Is Required"
    );
  } else if (f.type == "file-v2") {
    FIELDS_VALIDATION[f.key] = Yup.mixed().required("This Field Is Required");
  } else {
    FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
  }
});

const AddCompany = () => {
  const { t } = useTranslation();
  let navigate = useHistory();

  const { setData, loading, error, success } = useResponse(addCompany, () => {
    navigate.push("/companies");
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (values) => {
      let data = new FormData();
      Object.keys(values).map((key) => {
        if (values[key]) {
          data.append(key, values[key]);
        }
      });
      setData({ data, type: "add" });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Companies")}
            breadcrumbItem={t("Add") + " " + t("Company")}
          />

          <Form
            className="needs-validation"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <CompanyForm validation={validation} />

            <FormButtonHandler btnTxt="Add" loading={loading} />

            <ResultHandler
              error={error}
              success={success}
              successMsg={"Created Successfully!"}
            />
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddCompany;
